import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Waiting } from '../../components';
import { getUserRewardDetails } from '../../redux/actions/peopleHomeActions';
// import { getRewardPointsV2 } from '../../redux/actions/wellnessDashboardActions';
import { withTranslation } from 'react-i18next';
import RewardDetailsPage from '../../containers/Rewards/RewardDetailsPage';
import { TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { TabsWrapper } from '../common/commonStyles';
import { BorderBottom, TabBottomLine } from '../RecogntionAdmin/styles';
import CompanyRewardDetails from '../../containers/companyDetails/CompanyRewardDetails';

class AdminAchievementPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      firstIndex: 0,
      secondIndex: 0,
      companyId: props?.userProfileCompany?.company_details?.id,
      authtoken: props?.setUserDetails['auth_token']
    }
  }

  setActiveTab = (active) => {
    this.setState({ selectedTab: Number(active) })
  }

  componentDidMount() {
    this.setState({
      firstIndex: 10,
      secondIndex: 5,
    });
    const { getUserRewardDetails, userId } = this.props;
    getUserRewardDetails(userId);
    // getRewardPointsV2(userId, selectdUserAuth);
  }

  render() {
    const { reward,userId,brandingColor } = this.props;
    window.console.log("userId",userId)
    const {selectedTab} = this.state;
    if (!reward) {
      return <Waiting />
    }
   
    return (
      <div>
        <TopContainerWrapper style={{ flexWrap: "wrap" }}>
          <TabsWrapper background="transparent" padding="0px">
            <TabBottomLine isPadding={"0px"} background={brandingColor} active={selectedTab==1} onClick={()=>this.setActiveTab(1)}>
              {("Points")}
              <BorderBottom active={selectedTab==1} background={brandingColor} />
            </TabBottomLine>
            <TabBottomLine  isPadding={"0px"} background={brandingColor} active={selectedTab==2} onClick={()=>this.setActiveTab(2)}>
              {("Company Rewards")}
              <BorderBottom active={selectedTab==2} background={brandingColor} />
            </TabBottomLine>
          </TabsWrapper>
        </TopContainerWrapper> 
        { selectedTab === 1 ?
          <RewardDetailsPage admin /> : null
        }
        { selectedTab === 2 ?
          <CompanyRewardDetails admin/> : null
        }
      </div>
    );
  }
}

AdminAchievementPage.propTypes = {
  reward: PropTypes.object,
  monthlyRewardPoint: PropTypes.number,
  fitnessDetails: PropTypes.array,
  socialDetails: PropTypes.array,
  wellnessDetails: PropTypes.array,
  educationDetails: PropTypes.array,
  bonusWellness: PropTypes.array,
  bonusSocial: PropTypes.array,
  getUserRewardDetails: PropTypes.func,
  history: PropTypes.object,
  bonusFitness: PropTypes.array,
  bonusEducation: PropTypes.array,
  t: PropTypes.func,
  companyId: PropTypes.number,
  setUserDetails: PropTypes.array,
  //   getRewardPointsV2: PropTypes.func,
  userId: PropTypes.number,
  monthlyAdminRewardPoint: PropTypes.number,
  selectdUserAuth: PropTypes.string,
  userProfileCompany: PropTypes.array,
  brandingColor:PropTypes.string,
  companyBranding: PropTypes.object
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  fitnessDetails: state.wellnessDashboard.fitnessDetails,
  socialDetails: state.wellnessDashboard.socialDetails,
  wellnessDetails: state.wellnessDashboard.wellnessDetails,
  educationDetails: state.wellnessDashboard.educationDetails,
  bonusWellness: state.wellnessDashboard.bonusWellness,
  bonusSocial: state.wellnessDashboard.bonusSocial,
  bonusFitness: state.wellnessDashboard.bonusFitness,
  bonusEducation: state.wellnessDashboard.bonusEducation,
  monthlyAdminRewardPoint: state.wellnessDashboard.monthlyAdminRewardPoint,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
  brandingColor:state.wellnessDashboard.brandingColor,
});

const mapDispathcToProps = (dispatch) => ({
  getUserRewardDetails: (userId) => dispatch(getUserRewardDetails(userId)),
//   getRewardPointsV2: (userId, auth) => dispatch(getRewardPointsV2(userId, auth))
})

export default connect(mapStateToProps, mapDispathcToProps)(withTranslation()(AdminAchievementPage));